(function(angular) {
  'use strict';

  angular.module('asDemandMgr', ['osiAssets'])
      .run(['$rootScope', '$window', function($rootScope, $window){
          $rootScope.app = $window.app; // window.app will be available in all filters/controllers (first need for getting getUserTimezone)
      }]);

})(window.angular);
